var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_5126)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14.7283 7.43035C14.3474 7.42998 13.9822 7.27857 13.7129 7.00932C13.4435 6.74008 13.2919 6.37499 13.2913 5.99413V4H6.87432C6.62812 4 6.38434 4.0485 6.15689 4.14274C5.92944 4.23698 5.72278 4.3751 5.54873 4.54922C5.37467 4.72335 5.23662 4.93005 5.14247 5.15753C5.04831 5.38502 4.99991 5.62882 5 5.87502V17.1739C5 17.671 5.19746 18.1478 5.54897 18.4993C5.90047 18.8508 6.37722 19.0483 6.87432 19.0483H14.5778C15.0749 19.0483 15.5517 18.8508 15.9031 18.4993C16.2547 18.1478 16.4521 17.671 16.4521 17.1739V7.43035H14.7283Z",
    fill: "#FF8F00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.512 7.48064H14.7881C14.4073 7.48027 14.0421 7.32886 13.7727 7.05962C13.5033 6.79037 13.3518 6.42528 13.3512 6.04442V4.05029L16.512 7.48064Z",
    fill: "#FFD54F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8717 15.9336H9.16243C8.54464 15.9336 8.04382 16.4344 8.04382 17.0522V19.6488C8.04382 20.2666 8.54464 20.7674 9.16243 20.7674H17.8717C18.4895 20.7674 18.9903 20.2666 18.9903 19.6488V17.0522C18.9903 16.4344 18.4895 15.9336 17.8717 15.9336Z",
    fill: "#FF8F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.289 18.9126V19.419H11.7645V18.9126H12.289Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8478 19.0373H13.0628L12.9326 19.4189H12.399L13.1652 17.3398H13.7489L14.5151 19.4189H13.9753L13.8478 19.0373ZM13.7176 18.6521L13.4571 17.8817L13.1931 18.6521H13.7176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.222 17.3242V19.4186H14.715V17.3242H15.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6956 12.1759C10.6922 12.1458 10.6982 12.1153 10.7129 12.0887C10.7276 12.0622 10.7502 12.0408 10.7775 12.0276C10.8049 12.0145 10.8356 12.0101 10.8656 12.0152C10.8955 12.0203 10.9231 12.0345 10.9446 12.056C10.966 12.0774 10.9803 12.1051 10.9854 12.135C10.9905 12.1649 10.9861 12.1957 10.9729 12.223C10.9597 12.2504 10.9384 12.2729 10.9118 12.2876C10.8852 12.3023 10.8548 12.3084 10.8246 12.305L9.13001 13.9995L11.6607 12.759C11.6607 12.759 11.9446 11.6996 12.2676 11.377L11.6225 10.7319C11.3 11.055 10.2406 11.3393 10.2406 11.3393L9 13.87L10.6956 12.1759Z",
    fill: "#FFD54F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.0011L11.9989 10L11.5081 10.4909L12.5091 11.492L13 11.0011Z",
    fill: "#FFD54F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_5126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 16.7861,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.749e29e13b7b21a7897af3ec37fa295a.svg";
export { ForwardRef as ReactComponent };